export const extractPhoneNumber = (label) => {
  const match = String(label ?? "").match(/(\d{10})\s*$/);
  return match ? match[1] : label;
};
